import { useEffect, useRef } from 'react';

import getPreviousStatesCount from 'editor/src/store/editorModules/undoRedo/selector/getPreviousStatesCount';
import { useSelector } from 'editor/src/store/hooks';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

// Undo history holds only user actions: host design loads do not push to it,
// so it is a dirty flag that design.structureChanged (which also fires on system updates) is not.
function useEditsWatcher() {
  const hasEdits = useSelector((state) => getPreviousStatesCount(state) > 0);
  const sent = useRef(false);

  useEffect(() => {
    if (hasEdits !== sent.current) {
      sent.current = hasEdits;
      sendPostMessage('design.editsChanged', { hasEdits });
    }
  }, [hasEdits]);
}

export default useEditsWatcher;
